"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsLicenseType = void 0;
var StatsLicenseType;
(function (StatsLicenseType) {
    StatsLicenseType["Entry"] = "Entry";
    StatsLicenseType["Standard"] = "Standard";
    StatsLicenseType["Enterprise"] = "Enterprise";
})(StatsLicenseType = exports.StatsLicenseType || (exports.StatsLicenseType = {}));
